<template>
  <flex-column class="wrapper">
    <flex-header v-if="options.title || options.description">
      <div class="options-modal-header">
        <div class="padder">
          <h5>{{ options.title }}</h5>
          <div>{{ options.description }}</div>
        </div>
      </div>
    </flex-header>
    <flex-header v-if="searchEnabled">
      <div class="options-modal-header">
        <div class="padder">
          <search
            v-model="search"
            :loading="searching"
            :debounce="500"
            placeholder="Search"
          />
        </div>
      </div>
    </flex-header>
    <flex-body class="options-modal-body">
      <div class="padder" :class="{ columns }">
        <div
          class="choice"
          @click="select(choice)"
          v-for="choice in filteredChoices"
        >
          <flex-row gap center>
            <flex-cell shrink v-if="choice.icon">
              <div class="option-icon" v-html="choice.icon"></div>
            </flex-cell>
            <flex-cell>
              <div v-if="choice.title" class="title">{{ choice.title }}</div>
              <div v-if="choice.description" class="description">
                {{ choice.description }}
              </div>
            </flex-cell>
            <flex-cell shrink>
              <ux-icon right icon="fa-angle-right" />
            </flex-cell>
          </flex-row>
        </div>
      </div>
    </flex-body>
    <flex-footer class="options-modal-footer">
      <div class="padder">
        <!-- <flex-row> -->
        <!-- <flex-cell> -->
        <ux-button size="sm" @click="dismiss">Cancel</ux-button>
        <!-- </flex-cell>
 -->
        <!-- </flex-row> -->
      </div>
    </flex-footer>
  </flex-column>
</template>
<script>
import ModalMixin from "./ModalMixin";
import Search from "../form/inputs/search.vue";

export default {
  data() {
    return {
      selected: null,
      search: "",
    };
  },
  components: {
    Search,
  },
  mixins: [ModalMixin],
  computed: {
    searchEnabled() {
      if (this.options.search === false) {
        return false;
      }

      return this.options.choices.length > 10;
    },
    columns() {
      return this.options?.columns;
    },
    filteredChoices() {
      const self = this;
      let filtered = this.options?.choices || [];

      if (self.search) {
        const keywords = self.search.toLowerCase();
        const regexp = new RegExp(keywords);

        filtered = filtered
          .map(function (t) {
            t.searchString = `${t.title} ${t.plural} ${t.key}`.toLowerCase();
            return t;
          })
          .filter(function (t) {
            return regexp.test(t.searchString);
          });
      }

      return filtered;
    },
  },
  methods: {
    select(choice) {
      this.selected = choice;
      this.close(choice);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  border-radius: 0.5em;
  overflow: hidden;
  background: var(--bg1, #fff);
  border: 1px solid color-mix(in lab, currentColor 15%, transparent);
  text-align: center;
}

h5 {
  font-size: 1.2em;
  margin: 0;
}

.padder {
  padding: 1em;
  display: grid;
  gap: 0.5em;

  &.columns {
    grid-template-columns: auto auto;
  }
}

.options-modal-header {
  border-bottom: 1px solid color-mix(in lab, currentColor 15%, transparent);
}

.options-modal-footer {
  border-top: 1px solid color-mix(in lab, currentColor 15%, transparent);
}

.options-modal-body {
  background: color-mix(in lab, currentColor 5%, transparent);
}

.choice {
  padding: 1em;
  // border: 1px solid rgba(#000, 0.2);
  // background: var(--bg1, #fff);
  // margin-bottom: 0.3em;
  cursor: pointer;
  border-radius: 0.3em;
  text-align: left;

  background: var(--bg1, #fff);
  border: 1px solid color-mix(in lab, currentColor 15%, transparent);

  .option-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background: color-mix(in lab, currentColor 5%, transparent);

    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &:hover {
    border: 1px solid var(--primary);

    .ux-button {
      color: var(--primary);
    }
    // background: #fafafa;
    // background: color-mix(in lab, currentColor 15%, transparent);
  }

  .title {
    font-weight: 500;
    font-size: 1.1em;
  }

  .description {
    font-size: 0.8em;
    opacity: 0.5;
  }
}
</style>
